import { MONSTERS } from "./monsters";
import { state } from "./state";
import { monEl, monStage, trayEl, $ } from "../dom";
import { makePiece, sizePiece } from "./pieces";
import { renderProceed, updateHUD, refreshTrayState, renderHp } from "./flow";
import { sfxHit, sfxDefeat } from "../audio/sfx";

export function attack(): void {
  if (state.phase !== "fight") return;
  const mon = MONSTERS[state.monsterIndex];
  let dmg = 30 + Math.floor(Math.random() * 17); // 30-46
  const crit = Math.random() < 0.18;
  if (crit) dmg = Math.floor(dmg * 1.7);
  mon._hp = Math.max(0, (mon._hp ?? mon.hp) - dmg);

  sfxHit(crit);
  monEl.classList.remove("shake");
  void monEl.offsetWidth;
  monEl.classList.add("shake");
  spawnDamage(dmg, crit);
  renderHp();

  if (mon._hp <= 0) defeatMonster();
}

function spawnDamage(dmg: number, crit: boolean): void {
  const d = document.createElement("div");
  d.className = "dmg" + (crit ? " crit" : "");
  d.textContent = (crit ? "✸ " : "") + dmg;
  d.style.left = 40 + Math.random() * 120 + "px";
  d.style.top = 40 + Math.random() * 40 + "px";
  monStage.appendChild(d);
  setTimeout(() => d.remove(), 700);
}

function defeatMonster(): void {
  state.phase = "loot";
  sfxDefeat();
  monEl.classList.remove("alive", "shake");
  monEl.classList.add("slain");
  monStage.classList.add("looted");
  $("atkHint").textContent = "— slain! its hoard spills out —";
  setTimeout(() => {
    spawnLoot();
    renderProceed();
  }, 480);
}

function spawnLoot(): void {
  const mon = MONSTERS[state.monsterIndex];
  for (const key of mon.loot) {
    const p = makePiece(key);
    trayEl.appendChild(p.el);
    sizePiece(p);
  }
  refreshTrayState();
  updateHUD();
  if (window.matchMedia && window.matchMedia("(max-width:760px)").matches) {
    setTimeout(() => {
      const t = document.querySelector(".tray-wrap");
      if (t) t.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 90);
  }
}
